import React from "react";

import PreSessionDiagnosticScreen from "@/screens/PreSessionDiagnosticScreen";

function Page(): React.JSX.Element {
  return <PreSessionDiagnosticScreen />;
}

export default Page;
